"use client";

import React from "react";
import { Car, CarFront as VanFront, Bus } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
interface VehicleItem {
  id: string;
  name: string;
  icon: "Car" | "VanFront" | "Bus";
  description: string;
}
const VEHICLE_ICONS = {
  Car,
  VanFront,
  Bus
};
const FLEET_VEHICLES: VehicleItem[] = [{
  id: "standard-car",
  name: "Standard Car",
  icon: "Car",
  description: "Up to 4 passengers with luggage."
}, {
  id: "minivan",
  name: "Minivan",
  icon: "VanFront",
  description: "Up to 10 passengers with luggage."
}, {
  id: "bus",
  name: "Bus",
  icon: "Bus",
  description: "For groups of 10 or more passengers."
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.05
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 18
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: "easeOut"
    }
  }
};
export default function Fleet() {
  return <section id="our-fleet" data-nav="light" className="bg-background text-foreground py-20 border-b border-border">
      <div className="mx-auto max-w-[1136px] px-6">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mb-12">
          <p className="text-xs font-semibold tracking-wider text-primary uppercase mb-2">
            OUR VEHICLES
          </p>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight font-default">
            The Right Vehicle for Every Transfer
          </h2>
          <p className="text-base text-muted-foreground mt-2">
            Choose the vehicle that best fits your group size, luggage, and transfer needs.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" animate="show" className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FLEET_VEHICLES.map((vehicle, i) => {
          const IconComponent = VEHICLE_ICONS[vehicle.icon];
          return <motion.div key={vehicle.id} data-index={i} variants={cardVariants} className="flex">
                <Card className="flex flex-col justify-between w-full rounded-md border border-border bg-card shadow-xs transition-[border-color,box-shadow] duration-200 hover:border-primary hover:shadow-md">
                  <div>
                    <CardContent className="px-5 pt-6 pb-2">
                      <div className="mb-4 text-primary">
                        <IconComponent className="size-10" aria-hidden="true" />
                      </div>

                      <h3 className="text-lg font-semibold tracking-tight text-foreground font-default mb-2">
                        {vehicle.name}
                      </h3>

                      <p className="text-xs leading-relaxed text-muted-foreground">
                        {vehicle.description}
                      </p>
                    </CardContent>
                  </div>

                  <CardFooter className="px-5 pt-3 pb-5">
                    <Button asChild className="w-full h-10 rounded-md bg-primary text-primary-foreground font-medium text-sm transition-colors hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                      <Link to="/BookYourPrivateTransferPage">
                        Book This Vehicle
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}